import { forwardRef, ReactNode, Ref, useImperativeHandle, useRef, useState } from "react";
import DataLoader from "components/DataLoader/DataLoader";

type Props = {
  fetchArgs?: { [key: string]: any };
  onRefreshed?: (params: { [key: string]: any }) => void;
  fetchData: (
    args: { [key: string]: any } | any,
    onSuccess: (res: any) => void,
    onError: (d: any) => void
  ) => void;
  nullable?: boolean;
  asDialog?: boolean;
  hideSpinner?: boolean;
  dataPropName?: string;
  children: ReactNode;
};

type RefType = {
  refresh: () => void;
};

const RefreshableDataLoader = forwardRef((props: Props, forwardedRef: Ref<RefType>) => {
  const dataLoaderRef = useRef<any>(null);
  const [state, setState] = useState({
    refresh: false,
    fetchArgs: props.fetchArgs,
  });

  useImperativeHandle(forwardedRef, () => ({
    refresh(args?: { [key: string]: any }) {
      hdRefresh(args);
    },
  }));

  const hdRefresh = (args?: { [key: string]: any }) => {
    setState(prev => ({
      ...prev,
      refresh: true,
      fetchArgs: args || prev.fetchArgs,
    }));
  };

  const onRefreshed = () => {
    setState(prev => ({ ...prev, refresh: false }));
    if (!!props.onRefreshed && dataLoaderRef.current?.getData) {
      props.onRefreshed(dataLoaderRef.current.getData());
    }
  };

  return (
    <DataLoader
      fetchData={props.fetchData}
      fetchArgs={state.fetchArgs}
      refresh={state.refresh}
      callback={onRefreshed}
      nullable={props.nullable}
      asDialog={props.asDialog}
      dataPropName={props.dataPropName}
      hideSpinner={props.hideSpinner}
      ref={dataLoaderRef}
    >
      {props.children}
    </DataLoader>
  );
});

export default RefreshableDataLoader;
